module.exports = __webpack_public_path__ + "img/img_finish.png";